import APITemplate from '@api/APITemplate'
import store from '@state/store'
import con from '@services/connection'
import { comunicacaoPush, notificacao } from '@constants/URL'
import { getUnique } from '@utils/Format'

class APINotifications extends APITemplate {
  constructor() {
    super()
    this.timeout = null
  }

  async carregar() {
    const isCliente = (store.getters['user/currentUser'] || {}).IS_CLIENTE
    store.dispatch('notifications/setLoading', true)
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    if (isCliente) {
      await this._carregarCliente()
    } else {
      await this._carregarProfissional()
    }

    store.dispatch('notifications/setLoading', false)
    this.timeout = setTimeout(() => this.carregar(), 180000)
  }

  async _carregarCliente() {
    const qtd = await con.get(comunicacaoPush.qtd)
    if (qtd.status === 200) {
      store.dispatch('notifications/setQtdNotRead', qtd.value.quantidade)
    }
    const r = await con.get(comunicacaoPush.ler)
    if (r.status === 200) {
      store.dispatch(
        'notifications/setNotificacoes',
        getUnique(r.value || [], 'id')
      )
    }
  }

  async _carregarProfissional() {
    const qtd = await con.get(notificacao.qtd_not_read)
    if (qtd && qtd.status === 200) {
      store.dispatch('notifications/setQtdNotRead', qtd.value)
    }
    const r = await con.post(notificacao.read_news)
    if (r && r.status === 200) {
      store.dispatch(
        'notifications/setNotificacoes',
        getUnique(r.value || [], 'id')
      )
    }
  }

  async ler(id) {
    const isCliente = (store.getters['user/currentUser'] || {}).IS_CLIENTE
    if (!isCliente) {
      const r = await con.post(notificacao.set_read, { id_notificacao: id })
      if (r && r.status === 200) {
        await this.carregar()
      }
      return r
    }
    return null
  }

  async lerTodos() {
    const isCliente = (store.getters['user/currentUser'] || {}).IS_CLIENTE
    const url = isCliente ? comunicacaoPush.ler_todas : notificacao.set_read_all
    const r = await con.post(url)
    if (r && r.status === 200) {
      await this.carregar()
    }
    return r
  }

  stop() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}

const apiNotifications = new APINotifications()
export { apiNotifications }
